module.exports = __webpack_public_path__ + "img/risk2.dad5913a.png";